import { Modal } from 'flowbite-react';
import FormCreateRenter from '../forms/FormCreateRenter';
import { createRenter } from '../../../../common/services/renters.api';
import { useToastContext } from '../../../../common/components/ui/toast/toast.context';

type Props = {
  onClose?: () => void
  onSave: (renterId: string) => void
}

export default function ModalCreateRenter(props: Props) {
  const { notifySuccess, notifyError } = useToastContext()

  const handleCloseModal = () => { props.onClose && props.onClose() }

  async function handleSubmit(dataToSave) {
    try {
      const result = await createRenter(dataToSave)

      const { ok, data } = result
      if (ok && data) {
        props.onSave((data as { _id: string })?._id)
        notifySuccess(`Cliente "${(data as { name: string }).name}" cadastrado!`)
      }
      if (!result.ok) {
        notifyError(result.message as string)
      }

    } catch (err) {
      console.log(err)
      notifyError((err as Error).message as string)
    }

  }

  return (
    <Modal
      className='relative text-black'
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className='text-black'><h2 className='text-black'>Novo Cliente</h2></Modal.Header>
      <Modal.Body>
        <FormCreateRenter onSubmit={handleSubmit} />
      </Modal.Body>
    </Modal>
  );
}
